import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { PRODUCT } from '../store/actionTypes';
import { Product } from './models/product';

export const products = createApi({
  reducerPath: PRODUCT,
  baseQuery,
  tagTypes: ['Product'],
  endpoints: builder => ({
    products: builder.query<
      Product[],
      {
        page?: number;
        limit?: number;
        search?: string;
        subjectIds?: string;
        gradeLevelIds?: string;
        timeOfDay?: 'EARLY_MORNING' | 'MORNING' | 'AFTERNOON' | 'EVENING';
        sortBy?: 'EARLIEST' | 'LATEST';
      }
    >({
      query: variables => ({
        document: gql`
          query GetProducts(
            $page: Int
            $limit: Int
            $search: String
            $subjectIds: String
            $gradeLevelIds: String
            $timeOfDay: TimeOfDay
            $sortBy: SortOrder
          ) {
            getProducts(
              page: $page
              limit: $limit
              search: $search
              subjectIds: $subjectIds
              gradeLevelIds: $gradeLevelIds
              timeOfDay: $timeOfDay
              sortBy: $sortBy
            ) {
              id
              name {
                displayName
                language
              }
              productEvents
              classroom {
                size
                session {
                  start
                  end
                  terms
                }
                subject
                gradeLevel
                subjectData {
                  name {
                    text
                  }
                }
                gradeLevelData {
                  _id
                  level {
                    text
                  }
                }
              }
              pagination {
                pages
                items
              }
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getProducts,
    }),
  }),
});

export const { useProductsQuery } = products;
